import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dialog as MUIDailog } from '@material-ui/core';
import withSizes from 'react-sizes';

import { dialogSelectors, otpActions, otpSelectors, merchantSelectors, bankDetailsActionTypes, otpActionTypes } from '@store/ducks';
import SearchIFSC from '@components/BankDetails/SearchIFSC';
import BankConfirmation from '@components/BankDetails/ConfirmationDialog';
import UploadDocument from '@components/BankDetails/UploadDocument';
import VerifyOTP from '@components/BaseComponents/VerifyOTP';
import Sheet from 'deltoid/core/Blocks/Sheet';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import CustomLoader from '@components/BaseComponents/CustomLoader';

const Dialog = ({
  type,
  open,
  onClose: onCloseProp,
  isMobile,
  verifyOTP,
  identity,
  otpErrMsg,
  resentOtp,
  registeredMobile,
  resetOTPState,
}) => {
  const [retryTime, setRetryTime] = useState(60*1000);
  const [disableResend, setDisableResend] = useState(true);

  const getChild = type => {
    let child = '';
    switch(type) {
      case 'search-ifsc': {
        child = <SearchIFSC/>;
        break;
      }
      case 'bank-confirmation': {
        child = <BankConfirmation/>;
        break;
      }
      case 'bank-ws-loader': {
        child = <CustomLoader data-testid='websocket-loader'/>
        break;
      }
      case 'upload-bank-proof': {
        child = <UploadDocument/>
        break;
      }
      case 'verify-otp-bank': {
        child = (
          <VerifyOTP
            heading='Verify OTP'
            title={`Enter OTP sent on ${registeredMobile}`}
            subTitle='We have sent an OTP to your registered mobile number'
            handleVerifyOTP={(code) => verifyOTP(identity, code)}
            goBack={() => handleClose(type)}
            errMsg={otpErrMsg}
            resendOtp={() => {setRetryTime(60*1000); setDisableResend(true); resentOtp(identity);}}
            retryTime={retryTime}
            onTimerComplete={() => {setRetryTime(false); setDisableResend(false);}}
            disableResend={disableResend}
          />
        )
        break;
      }
      default: {
        child = null;
      }
    }
    return child;
  }

  const handleClose = (type) => {
    let actionType = null;
    switch(type) {
      case 'upload-bank-proof':
        actionType = bankDetailsActionTypes.resetUploadBankProof;
        break;
      case 'verify-otp-bank':
        actionType = otpActionTypes.resetOtpState;
        break;
    }
    onCloseProp(actionType);
  };

  const maxWidth = (type) => {
    switch(type) {
      case 'upload-bank-proof':
        return 'sm'
      default:
        return 'xs';
    }
  }

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));


  return (
    <>
      {
        getChild(type) ? (
          !isMobile ? (
            <MUIDailog
            open={open}
            onClose={() => handleClose(type)}
            maxWidth={maxWidth(type)}
            fullWidth={['bank-confirmation', 'upload-bank-proof', 'bank-ws-loader'].includes(type)}
            fullScreen={type === 'bank-ws-loader' ? fullScreen : false}
            PaperProps={
              type === 'bank-ws-loader'
                ? {
                  style: {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    justifyContent: 'center',
                    display: 'flex',
                    alignItems: 'center',
                  },
                }
                : {}
            }
            >
            {getChild(type)}
            </MUIDailog>
          ) : (
            <Sheet className={`${type != 'bank-ws-loader' ? 'bg-white' : 'd-flex justify-content-center'} sheet-b-radius`} open={open} bottom
              onOverlayClick={type=='bank-ws-loader' ? () => {} : () => handleClose(type)}
            >
              {getChild(type)}
            </Sheet>
          )
        ) : <></>
      }
    </>
  )
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});
const ResponsiveDialog = withSizes(mapSizesToProps)(Dialog);

const mapStateToProps = (state) => {
  return {
    open: dialogSelectors.open(state),
    type: dialogSelectors.type(state),
    identity: merchantSelectors.getMerchantEmail(state),
    registeredMobile: merchantSelectors.getMerchantMobile(state),
    otpErrMsg: otpSelectors.getError(state),
  };
};

const mapDispatchToProps = dispatch => ({
  verifyOTP: (identity, code) => dispatch(otpActions.verifyOTP(
    identity, 'SignIn', code, bankDetailsActionTypes.updateBankDetails,
  )),
  resentOtp: (email) => dispatch(otpActions.sendOTP(
    ['email', 'sms'],
    email,
    'update_bank_details',
    'SignIn',
  )),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveDialog);
